import ProductModificationModal, { SubmitValues } from './ProducModificationModal';
export default ProductModificationModal;

export type { SubmitValues };
